// extracted by mini-css-extract-plugin
export default {"title":"DeleteAccountButton_title__M+eIf","secondaryText":"DeleteAccountButton_secondaryText__ukzn1","inputWithLabel":"DeleteAccountButton_inputWithLabel__Gqg3j"};